export default {
  namespaced: true,

  state: () => ({
    transactions: {
      data: [],
      links: {},
      meta: {},
    },
    isLoading: false,
    filtersPayment: [],
    filtersOrder: [],
    filterVoucher: '',
    tabStatusList: [
      {
        title: 'Belum Dibayar',
        value: 'unpaid',
        category: 'payment',
        color: 'secondary',
        count: 0,
      },
      {
        title: 'Sudah Dibayar',
        value: 'paid',
        category: 'payment',
        color: 'dark',
        count: 0,
      },
      {
        title: 'Tidak Dibayar',
        value: 'cancelledPay',
        category: 'payment',
        color: 'danger',
        count: 0,
      },
      {
        title: 'Diproses',
        value: 'accepted',
        category: 'order',
        color: 'secondary',
        count: 0,
      },
      {
        title: 'Dikirim',
        value: 'pickedup',
        category: 'order',
        color: 'dark',
        count: 0,
      },
      {
        title: 'Req. Pickup',
        value: 'pickup_requested',
        category: 'order',
        color: 'warning',
        count: 0,
      },
      {
        title: 'Selesai',
        value: 'delivered',
        category: 'order',
        color: 'success',
        count: 0,
      },
      {
        title: 'Batal',
        value: 'cancelled',
        category: 'order',
        color: 'danger',
        count: 0,
      },
    ],
    transaction: '',
    trackHistory: [],
    photoHistory: [],
    trackStatus: '',
    summary: {
      accepted: 0,
      pickedup: 0,
      unpaid: 0,
      pickup_requested: 0,
    },
  }),

  mutations: {
    SET_TRANSACTIONS(state, payload) {
      state.transactions = payload
    },
    SET_TRANSACTION(state, payload) {
      state.transaction = payload
    },
    SET_TRACK_HISTORY(state, payload) {
      state.trackHistory = payload
    },
    SET_PHOTO_HISTORY(state, payload) {
      state.photoHistory = payload
    },
    SET_TRACKING_STATUS(state, payload) {
      state.trackStatus = payload
    },
    SET_FILTERS_PAYMENT(state, payload) {
      state.filtersPayment = payload
    },
    SET_FILTERS_ORDER(state, payload) {
      state.filtersOrder = payload
    },
    SET_FILTERS_VOUCHER(state, payload) {
      state.filterVoucher = payload
    },
    SET_SUMMARY(state, payload) {
      state.summary = payload
    },
    SET_COUNT_STATUS(state, payload) {
      Object.entries(payload).forEach(([key, value]) => {
        const index = state.tabStatusList.findIndex(el => el.value === key)
        state.tabStatusList[index].count = value
      })
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload
    },
    RESET_TRANSACTION(state) {
      state.transaction = ''
    },
  },

  actions: {
    async exportTransactions({ commit }) {
      function formatDate(date) {
        if (date) {
          const myDate = new Date(date)
          const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][myDate.getMonth()]
          return `${myDate.getDate()} ${month} ${myDate.getFullYear()}`
        }
        return ''
      }
      function formatMonth(date) {
        if (date) {
          const myDate = new Date(date)
          const month = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'][myDate.getMonth()]
          return `${month}`
        }
        return ''
      }
      try {
        const url = 'v1/admin/transactions/export?filter[payment_statuses]=paid&sort=-created_at'

        const response = await this._vm.$http.get(url)

        const transactions = response.data.data.rows

        const data = []
        transactions.forEach(transaction => {
          transaction.items.forEach((item, index) => {
            data.push([
              index === 0 ? transaction.id : '',
              index === 0 ? `"${transaction.customer_name}"` : '',
              index === 0 ? `"${transaction.merchant_name}"` : '',
              `"${item.product_name}"`,
              index === 0 ? formatDate(transaction.paid_date) : '',
              index === 0 ? formatMonth(transaction.paid_date) : '',
              item.price,
              index === 0 ? transaction.total_sales_amount : '',
              index === 0 ? transaction.sales_discount : '',
              index === 0 ? transaction.after_discount : '',
              index === 0 ? transaction.delivery_fee : '',
              index === 0 ? transaction.mini_point_discount : '',
              index === 0 ? transaction.total_payment : '',
            ])
          })
        })

        const csv = [
          [
            'Id',
            'Customer Name',
            'Merchant',
            'Description',
            'Paid Date',
            'Period',
            'Price per item',
            'Total Sales Amount',
            'Sales Discount',
            'After Discount',
            'Ongkir Customer',
            'Mini Points',
            'Total Payment',
          ],
          ...data,
        ]
          .map(e => e.join(','))
          .join('\n')

        const anchor = document.createElement('a')
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`
        anchor.target = '_blank'
        anchor.download = 'TransaksiMiniapoly.csv'
        anchor.click()

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async getTransactions({ commit }, {
      page = null,
      limit = null,
      keyword = undefined,
      filter = {},
      voucher = undefined,
      sort = '-accepted_at',
    } = {}) {
      try {
        commit('SET_LOADING', true)

        const url = '/v2/admin/transactions'

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            limit,
            ...filter,
            'filter[voucher]': voucher,
            'filter[keyword]': keyword,
            sort,
          },
        })

        commit('SET_TRANSACTIONS', response.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        commit('SET_LOADING', false)
        return error
      }
    },
    async getRawTransactions({ commit }, {
      page = null,
      limit = null,
      keyword = undefined,
      filter = {},
      voucher = undefined,
      sort = '-accepted_at',
    } = {}) {
      try {
        const url = '/v2/admin/transactions'

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            limit,
            ...filter,
            'filter[voucher]': voucher,
            'filter[keyword]': keyword,
            sort,
          },
        })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async setFiltersPayment({ commit }, filters) {
      commit('SET_FILTERS_PAYMENT', filters)
    },
    async setFiltersOrder({ commit }, filters) {
      commit('SET_FILTERS_ORDER', filters)
    },
    async setFiltersVoucher({ commit }, filters) {
      commit('SET_FILTERS_VOUCHER', filters)
    },
    async getDetailTransaction({ commit }, idTransaction) {
      try {
        const url = `/v1/admin/transactions/${idTransaction}`

        const response = await this._vm.$http.get(url)

        commit('SET_TRANSACTION', response.data.data)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async getTrack({ commit }, { transaction }) {
      try {
        const url = `/v2/transactions/${transaction}/track-delivery`

        const response = await this._vm.$http.get(url)

        if (response.data.error) {
          commit('SET_TRACK_HISTORY', [])

          commit('SET_TRACKING_STATUS', '')

          return null
        }

        const data = response.data.history.reverse()
        const photoHistory = response.data.photo_history || []

        commit('SET_TRACK_HISTORY', data)
        commit('SET_PHOTO_HISTORY', photoHistory)
        commit('SET_TRACKING_STATUS', response.data.status ? response.data.status.toLowerCase() : '')

        return response.data
      } catch (error) {
        return error
      }
    },
    async onSubmitDelivery({ commit }, { idTransaction, resi = '' }) {
      try {
        const url = `/v1/admin/order/${idTransaction}/delivery`
        const response = await this._vm.$http.post(url, {
          tracking_number: resi,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menandai telah dikirim!',
        }, { root: true })

        return response
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async onChangeAwb({ commit }, { idTransaction, resi = '' }) {
      try {
        const url = `/v1/admin/order/${idTransaction}/change-awb`
        const response = await this._vm.$http.post(url, {
          tracking_number: resi,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil mengubah No. Resi',
        }, { root: true })

        return response
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async onChangeCourier({ commit }, { idTransaction, courierId, service = '' }) {
      try {
        const url = `/v1/admin/order/${idTransaction}/change-courier`
        const response = await this._vm.$http.post(url, {
          courier_id: courierId,
          service,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil mengubah Kurir',
        }, { root: true })

        return response
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async onCancelDelivery({ commit }, { idTransaction }) {
      try {
        const url = `/v1/admin/order/${idTransaction}/cancel-delivery`
        const response = await this._vm.$http.post(url)

        commit('response/SET_SUCCESS', {
          message: 'Pesanan kembali diproses',
        }, { root: true })

        return response
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        throw error
      }
    },
    async onSubmitDelivered({ commit }, idTransaction) {
      try {
        const url = `/v1/admin/order/${idTransaction}/delivered`
        const response = await this._vm.$http.post(url)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menandai telah selesai!',
        }, { root: true })

        return response
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async requestPickup({ commit }, { id, data }) {
      const url = `/v1/admin/order/${id}/pickup`
      const response = await this._vm.$http.post(url, data)

      commit('response/SET_SUCCESS', {
        message: 'Pickup dijadwalkan. Mohon tunggu penjemputan!',
      }, { root: true })

      return response
    },
    async requestDropOff({ commit }, { id, data }) {
      const url = `/v1/admin/order/${id}/dropoff`
      const response = await this._vm.$http.post(url, data)

      commit('response/SET_SUCCESS', {
        message: 'Resi Drop-off dibuat. Harap antar ke Cabang!',
      }, { root: true })

      return response
    },
    async requestPickupRocket({ commit }, { id, data }) {
      const url = `/v1/admin/order/${id}/pickup-rocket`
      const response = await this._vm.$http.post(url, data)

      commit('response/SET_SUCCESS', {
        message: 'Pickup dijadwalkan. Mohon tunggu penjemputan!',
      }, { root: true })

      return response
    },
    async onCancelOrder({ commit }, { idTransaction, ...payload }) {
      try {
        const url = `/v1/admin/order/${idTransaction}/cancel`
        const response = await this._vm.$http.post(url, payload)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil membatalkan pesanan!',
        }, { root: true })

        return response
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async getSummaryTransaction({ commit }) {
      try {
        const url = '/v1/admin/transactions/count/status'
        const response = await this._vm.$http.get(url)

        commit('SET_SUMMARY', response.data.data)
        commit('SET_COUNT_STATUS', response.data.data)

        return response
      } catch (error) {
        return error
      }
    },
    async updateGiftProductContributor({ commit }, { id, data }) {
      try {
        const url = `/v1/admin/gift-product-contributor/${id}/change`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil mengubah ucapan!',
        }, { root: true })

        return response
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal mengubah ucapan!',
        }, { root: true })
        throw error
      }
    },
  },
}
